"use strict";

var _defineProperty = require("/home/runner/work/moderneyegallery/moderneyegallery/node_modules/@babel/runtime/helpers/defineProperty.js");

var _objectWithoutProperties = require("/home/runner/work/moderneyegallery/moderneyegallery/node_modules/@babel/runtime/helpers/objectWithoutProperties.js");

var _taggedTemplateLiteral = require("/home/runner/work/moderneyegallery/moderneyegallery/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _excluded = ["label"],
    _excluded2 = ["label"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_1 = __importDefault(require("@emotion/styled"));

var object_hash_1 = __importDefault(require("object-hash"));

var react_1 = __importStar(require("react"));

var react_redux_1 = require("react-redux");

var redux_form_1 = require("redux-form");

var index_1 = require("../../index");

var ButtonSC = styled_1.default.button(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));
var FormSC = styled_1.default.form(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral([""])));
var FormBodySC = styled_1.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral([""])));
var FormFooterSC = styled_1.default.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n"])));
var MessageSC = styled_1.default.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral([""])));

var Actions = function Actions(_ref) {
  var id = _ref.id,
      values = _ref.values;

  var _ref2 = (0, react_1.useContext)(index_1.FormidableContext),
      sc = _ref2.sc;

  if (!values) {
    return null;
  }

  var tmp = Array.isArray(values) ? values : [values];
  return react_1.default.createElement(react_1.default.Fragment, null, tmp.map(function (a) {
    if (a.actions) {
      var div = a;
      return react_1.default.createElement("div", {
        key: "form_actions_div_".concat((0, object_hash_1.default)(div.actions)),
        className: div.className
      }, div.actions.map(function (_ref3, i) {
        var label = _ref3.label,
            actionProps = _objectWithoutProperties(_ref3, _excluded);

        return react_1.default.createElement(ButtonSC, _objectSpread({
          key: "form_actions_".concat((0, object_hash_1.default)({
            id: id,
            label: label,
            index: i
          })),
          as: sc && sc.button
        }, actionProps), label);
      }));
    }

    return (Array.isArray(a) ? a : [a]).map(function (_ref4, i) {
      var label = _ref4.label,
          actionProps = _objectWithoutProperties(_ref4, _excluded2);

      return react_1.default.createElement(ButtonSC, _objectSpread({
        key: "form_actions_".concat((0, object_hash_1.default)({
          id: id,
          label: label,
          index: i
        })),
        as: sc && sc.button
      }, actionProps), label);
    });
  }));
};

var Form = function Form(props) {
  var actions = props.actions,
      bodyProps = props.bodyProps,
      cancelProps = props.cancelProps,
      children = props.children,
      className = props.className,
      error = props.error,
      footerProps = props.footerProps,
      handleSubmit = props.handleSubmit,
      _props$hideSubmitButt = props.hideSubmitButton,
      hideSubmitButton = _props$hideSubmitButt === void 0 ? false : _props$hideSubmitButt,
      id = props.id,
      _props$isSubmissive = props.isSubmissive,
      isSubmissive = _props$isSubmissive === void 0 ? true : _props$isSubmissive,
      name = props.name,
      pristine = props.pristine,
      _props$removePristine = props.removePristine,
      removePristine = _props$removePristine === void 0 ? false : _props$removePristine,
      submitProps = props.submitProps,
      submitting = props.submitting;

  var _ref5 = (0, react_1.useContext)(index_1.FormidableContext),
      sc = _ref5.sc,
      t = _ref5.t;

  return react_1.default.createElement(FormSC, {
    as: sc && sc.form,
    className: className,
    id: id,
    name: "".concat(name, "-form"),
    onSubmit: handleSubmit
  }, react_1.default.createElement(FormBodySC, _objectSpread({}, bodyProps), children, error && react_1.default.createElement(MessageSC, {
    as: sc && sc.formMessage,
    color: "error"
  }, t ? t(error) : error)), react_1.default.createElement(FormFooterSC, _objectSpread({}, footerProps), react_1.default.createElement(Actions, {
    id: id,
    values: actions
  }), (cancelProps === null || cancelProps === void 0 ? void 0 : cancelProps.onClick) && react_1.default.createElement(ButtonSC, _objectSpread({
    as: sc && sc.button
  }, cancelProps), t ? t((cancelProps === null || cancelProps === void 0 ? void 0 : cancelProps.label) || 'cancel') : (cancelProps === null || cancelProps === void 0 ? void 0 : cancelProps.label) || 'cancel'), !hideSubmitButton && react_1.default.createElement(ButtonSC, _objectSpread(_objectSpread({
    as: sc && sc.button
  }, submitProps), {}, {
    disabled: // !isSubmissive || invalid || pristine || submitting || !valid
    !isSubmissive || !removePristine && pristine || submitting,
    type: "submit"
  }), ((submitProps === null || submitProps === void 0 ? void 0 : submitProps.label) || !(submitProps === null || submitProps === void 0 ? void 0 : submitProps.iconLeft) && !(submitProps === null || submitProps === void 0 ? void 0 : submitProps.iconRight)) && (t ? t((submitProps === null || submitProps === void 0 ? void 0 : submitProps.label) || 'submit') : (submitProps === null || submitProps === void 0 ? void 0 : submitProps.label) || 'submit'))));
};

var ReduxForm = (0, redux_form_1.reduxForm)({})(Form);

var mapStateToProps = function mapStateToProps(state, props) {
  return {
    asyncChangeFields: props.asyncChangeFields,
    asyncValidate: props.asyncValidate,
    destroyOnUnmount: undefined !== props.destroyOnUnmount ? props.destroyOnUnmount : true,
    enableReinitialize: !!props.enableReinitialize,
    forceUnregisterOnUnmount: !!props.forceUnregisterOnUnmount,
    form: props.name,
    keepDirtyOnReinitialize: !!props.keepDirtyOnReinitialize,
    touchOnChange: undefined !== props.touchOnChange ? props.touchOnChange : false,
    updateUnregisteredFields: undefined !== props.updateUnregisteredFields ? props.updateUnregisteredFields : false,
    validate: props.validate
  };
};

exports.default = (0, react_redux_1.connect)(mapStateToProps)(ReduxForm);